import { Subscription } from 'rxjs';
import { isReportLoadingState } from './../reports.selectors';
import { CreateReportRequest } from './../reports.actions';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'app-rate-book-reports',
  templateUrl: './rate-book-reports.component.html',
  styleUrls: ['./rate-book-reports.component.css']
})
export class RateBookReportsComponent implements OnInit, OnDestroy {

  public form: FormGroup;
  public isLoading: boolean;
  private state$: Subscription;

  constructor(private store: Store<any>, private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      type: new FormControl('rateBook'),
      filename: new FormControl('Valuation and Rate Book'),
    });

    this.state$ = this.store.pipe(select(isReportLoadingState)).subscribe((isLoading: boolean) => {
      this.isLoading = isLoading
    });
  }

  createReport() {
    this.store.dispatch(new CreateReportRequest(this.form.value))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

}
